import React from 'react';
import Button from "../../components/Button";
import SelectEmpleados from "../../components/SelectEmpleados";
import SelectDepartamentos from "../../components/SelectDepartamentos";
import "../../css/ModalExportarAsistencia.css";
import ReactDOM from 'react-dom';

const ModalExportarAsistencia = ({
    onClose,
    detalle,
    setDetalle,
    uuid,
    setUuid,
    selectedDepartments,
    setSelectedDepartments,
    dateExport,
    handleExportChange,
    detail,
    setDetail,
    submitExport
}) => {
    return ReactDOM.createPortal(
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h2>Exportar Reporte</h2>
                    <button onClick={onClose} className="close-button">X</button>
                </div>
                <div className="modal-body">
                    <div className="contenedorBotonesFiltroEmpleado">
                        <button onClick={() => setDetalle(!detalle)} className={`${!detalle ? 'buttonFiltroAzul' : 'buttonFiltroGris'}`}>Por empleado</button>
                        <button onClick={() => setDetalle(!detalle)} className={`${detalle ? 'buttonFiltroAzul' : 'buttonFiltroGris'}`}>Todos los empleados</button>
                    </div>
                    {!detalle && (
                        <div className="inputSelectEmpleado">
                            <SelectEmpleados setUuid={setUuid} />
                        </div>
                    )}
                    <div className="inputSelectEmpleado">
                        <SelectDepartamentos
                            selectedDepartments={selectedDepartments}
                            setSelectedDepartments={setSelectedDepartments}
                            placeholder="Selecciona uno o más departamentos"
                        />
                    </div>
                    <div className="contenedorDesadeHasta">
                        <div>
                            <p>Desde</p>
                            <input className="inputDate" type="date" name='exportDesde' onChange={handleExportChange} />
                        </div>
                        <div>
                            <p>Hasta</p>
                            <input className="inputDate" name='exportHasta' onChange={handleExportChange} type="date" />
                        </div>
                    </div>
                    <div className="contenedorRarioButtons">
                        <div className="contenedorRadio">
                            <input type="radio" value={true} name="detalle" checked={detail === true} onChange={e => setDetail(e.target.value === 'true')} />
                            <p>Con detalle</p>
                        </div>
                        <div className="contenedorRadio">
                            <input type="radio" value={false} name='detalle' checked={detail === false} onChange={e => setDetail(e.target.value === 'true')} />
                            <p>Sin detalle</p>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <Button onClick={submitExport} msj='Exportar Excel' tipe='violeta' />
                </div>
            </div>
        </div>,
        document.body
    );
};

export default ModalExportarAsistencia;
